import api from './axiosConfig';

const mediaService = {
  // Buscar mídias de um campeonato
  getMediaForChampionship: async (championshipId) => {
    console.log(`[mediaService] getMediaForChampionship chamado com championshipId: ${championshipId}`);
    try {
      const response = await api.get(`/media/${championshipId}`);

      console.log('[mediaService] resposta bruta da API (response.data):', response.data);

      const data = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.medias)
          ? response.data.medias
          : Array.isArray(response.data?.data)
            ? response.data.data
            : [];

      console.log('[mediaService] dados extraídos da resposta:', data);

      return { success: true, data };
    } catch (error) {
      console.error('[mediaService] Erro ao buscar mídias:', error.response?.data || error.message);
      return { success: false, error: 'Erro ao buscar mídias.' };
    }
  },

  // Upload de mídia
  uploadMedia: async (championshipId, files, title, description) => {
    console.log(`[mediaService] uploadMedia chamado com championshipId: ${championshipId}, title: "${title}", description: "${description}", arquivos:`, files);
    const formData = new FormData();
    files.forEach(file => formData.append('mediafiles', file));
    formData.append('title', title);
    formData.append('description', description);

    try {
      const response = await api.post(`/media/${championshipId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('[mediaService] upload realizado com sucesso:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('[mediaService] Erro no upload:', error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.error || 'Erro no upload',
        message: error.response?.data?.message || '',
      };
    }
  },

  // Excluir mídia
  deleteMedia: async (mediaId) => {
    console.log(`[mediaService] deleteMedia chamado para mediaId: ${mediaId}`);
    try {
      await api.delete(`/media/${mediaId}`);
      console.log('[mediaService] mídia excluída com sucesso');
      return { success: true };
    } catch (error) {
      console.error('[mediaService] Erro ao excluir mídia:', error.response?.data || error.message);
      return { success: false, error: 'Erro ao excluir mídia.' };
    }
  },

  // Obter URL completa do arquivo no Cloudinary
  getMediaUrl: (media) => {
    console.log('[mediaService] getMediaUrl (Cloudinary):', media.filePath);
    return media.filePath;
  }
};

export default mediaService;
